import {
	PUBLIC_PAGE_API_ENDPOINT,
	PUBLIC_MYPAGES_API_ENDPOINT,
} from "../../../constants"

export const updateInterest = (name: string, checked: boolean) => {
	const url =
		PUBLIC_PAGE_API_ENDPOINT +
		PUBLIC_MYPAGES_API_ENDPOINT +
		`/interests?name=${name}&value=${String(checked)}`

	return fetch(url, {
		method: "PUT",
	}).then((res) => {
		return res.json().then((json) => ({
			success: res.status === 200,
			data: json,
			statusCode: res.status,
		}))
	})
}
